import { createSlice } from "@reduxjs/toolkit";
import { getThemeColor, setThemeColor } from "../../utils/localStorageFunction";

// Check LocalStorage first, else use default colors
const savedTheme = getThemeColor();
const initialState = savedTheme || {
  primaryColor: "#FFA447", // Default Primary
  secondaryColor: "#D24545", // Default Secondary
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setPrimaryColor: (state, action) => {
      state.primaryColor = action.payload;
      setThemeColor({
        primaryColor: state.primaryColor,
        secondaryColor: state.secondaryColor,
      });
    },
    setSecondaryColor: (state, action) => {
      state.secondaryColor = action.payload;
      setThemeColor({
        primaryColor: state.primaryColor,
        secondaryColor: state.secondaryColor,
      });
    },
  },
});

export const { setPrimaryColor, setSecondaryColor } = themeSlice.actions;
export default themeSlice.reducer;
